import styled from 'styled-components';
export const getPlayerUIContainerStyles = (blockingReason) => {
    return {
        width: '100%',
        height: '100%',
        backgroundColor: blockingReason ? '#000' : 'transparent',
    };
};
export const ProgressBarContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
`;
ProgressBarContainer.displayName = 'ProgressBarContainer';
export const ProgressBar = styled.div `
    flex: 1 1 auto;
    width: 100%;
    margin: 0 20px;
`;
ProgressBar.displayName = 'ProgressBar';
export const FlexContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
`;
FlexContainer.displayName = 'FlexContainer';
//# sourceMappingURL=index.js.map